<template>
  <div class="bottom">
    <div class="content">
      <div class="content-info">
        <div class="content-info-left">
          <p>联系我们</p>
          <div class="short_line"></div>
          <ul>
            <li>客服电话：{{ info.consumerHotline }}</li>
            <li></li>
            <li>公司邮箱：{{ info.companyEmail }}</li>
          </ul>
          <button @click="goOpen">
            产品开通申请
          </button>
        </div>
        <div class="content-info-right">
          <img src="@/assets/qrcode.jpg" alt=""/>
          <p>微信扫一扫，关注「树莓未来校园」公众号</p>
          <p>获取更多前沿资讯</p>
        </div>
      </div>
      <div class="lien"></div>
      <div class="company-information">
        <span>版权所有 © 浙江树莓信息科技有限公司</span>
        <span>|</span>
        <a :href="info.caseNumberLink" target="_blank">备案号：{{ info.caseNumber }}</a>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "newBottom",
  data() {
    return {
      info: {
        consumerHotline: '15957613036',
        companyEmail: 'shumeikeji@zjbenti.com',
        caseNumber: '浙ICP备2022036546号-1',
        caseNumberLink: 'https://beian.miit.gov.cn/#/Integrated/index'
      },
      // openLink: 'http://api.smart.ztengit.com/v4/manage/apply'
      openLink: 'https://h5.smart.ztengit.com/v4/manage/apply'
    }
  },
  methods: {
    goOpen() {
      location.href = this.openLink
    }
  }
}
</script>

<style scoped>
.bottom {
  width: 100%;
  background: #384357;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2083333333333333rem 1.875rem 0.1041666666666667rem;
  box-sizing: border-box;
}
.content {
  width: 100%;
  height: 100%;
}
.content-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.1197916666666667rem;
}
.content-info-left p {
  text-align: left;
  font-size: 0.09375rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 0.1041666666666667rem;
}
.short_line {
  width: 0.1563rem;
  height: 0.0104rem;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 0.1563rem;
}

.content-info-left ul {
  display: grid;
  list-style-type: none;
  text-align: left;
  padding: 0;
  margin: 0;
  grid-template-columns: repeat(2, auto);
  grid-row-gap: 0.078125rem;
  grid-column-gap: 0.3125rem;
}
.content-info-left ul li {
  font-size: 0.0729166666666667rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}
.content-info-left button {
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #FFFFFF 0%, #C7E1FF 100%);
  border-radius: 28px;
  padding: 0.046875rem 0.09375rem;
  font-size: 0.0833333333333333rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #384357;
  margin-top: 0.2083333333333333rem;
}
.content-info-left button::after {
  content: '';
  width: 0.09375rem;
  height: 0.09375rem;
  background: url("~@/assets/arrow.png") no-repeat;
  background-size: 100% 100%;
  margin-left: 0.0416666666666667rem;
}
.content-info-right {
  padding-right: 1.136666666666667rem;
  text-align: left;
}
.content-info-right img {
  width: 0.78125rem;
  height: 0.78125rem;
  margin-bottom: 0.1041666666666667rem;
}
.content-info-right p {
  margin: 0;
}
.content-info-right p:first-of-type {
  font-size: 0.0729166666666667rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  margin-bottom: 0.0625rem;
}
.content-info-right p:last-of-type {
  font-size: 0.09375rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
}
.lien {
  width: 100%;
  height: 0.0052083333333333rem;
  background: #FFFFFF;
  opacity: 0.1;
  margin-bottom: 0.1041666666666667rem
}
.company-information {
  font-size: 0.0625rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  text-align: left;
}
.company-information span:last-of-type {
  margin: 0 0.1041666666666667rem;
}
.company-information a {
  text-decoration-line: none;
  font-weight: 400;
  font-size: 0.0625rem;
  color: #FFFFFF;
}
</style>
